module.exports = __webpack_public_path__ + "static/media/62-iveco-mercedes.515aa7db.jpg";